import { render } from "./TopProjectMenu.vue?vue&type=template&id=406e6948"
import script from "./TopProjectMenu.vue?vue&type=script&lang=js"
export * from "./TopProjectMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__